import {
  ContainerProps as MantineContainerProps,
  Container as MantineContainer,
} from '@mantine/core';

export type ContainerProps = MantineContainerProps;

export const Container = MantineContainer;

Container.displayName = 'Container';
